// @ts-ignore
import webvarsConfigurationService from 'common/services/webvarsConfigurationService'
import {CaptureExtensionUtils} from 'powtoon-commons/services/capture-extension'
import {createLogger} from 'logging'
const logger = createLogger('powtoon-capture-extension')

const createInstance = () => {
  try {
    return new CaptureExtensionUtils(
      webvarsConfigurationService.getWebVar('captureExtensionId'),
      webvarsConfigurationService.getWebVar('captureExtensionStoreLink')
    )
  }
  catch (error) {
    logger.error(new Error('Failed instantiating CaptureExtensionUtils'), error)
    return new CaptureExtensionUtils('ERROR_ID', webvarsConfigurationService.getWebVar('captureExtensionStoreLink'))
  }
}

export const extensionUtils = createInstance()
